import { computed, onBeforeUnmount, ref } from 'vue';

const MAX_MODAL_STACK_LEVEL = 20;
const modalStack = [];
const modalStackIndexes = new Map();
let nextModalStackId = 1;

const refreshModalStackIndexes = () => {
	modalStackIndexes.forEach((modalStackIndex, modalStackId) => {
		const index = modalStack.indexOf(modalStackId);
		modalStackIndex.value = index === -1 ? 0 : index;
	});
};

export function useModalStack() {
	const modalStackId = nextModalStackId++;
	const modalStackIndex = ref(0);

	modalStackIndexes.set(modalStackId, modalStackIndex);

	const modalStackLevel = computed(() => Math.min(modalStackIndex.value, MAX_MODAL_STACK_LEVEL));
	const modalStackClass = computed(() => `modal-stack-level-${modalStackLevel.value}`);
	const backdropStackClass = computed(() => `modal-backdrop-stack-level-${modalStackLevel.value}`);

	const activateModalStack = () => {
		if (!modalStack.includes(modalStackId)) {
			modalStack.push(modalStackId);
		}

		refreshModalStackIndexes();
	};

	const releaseModalStack = () => {
		const index = modalStack.indexOf(modalStackId);

		if (index !== -1) {
			modalStack.splice(index, 1);
		}

		refreshModalStackIndexes();
	};

	onBeforeUnmount(() => {
		releaseModalStack();
		modalStackIndexes.delete(modalStackId);
	});

	return {
		activateModalStack,
		backdropStackClass,
		modalStackClass,
		releaseModalStack,
	};
}
